var _a;
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
var initialState = {
    modals: []
};
var modalId = 0;
export var showSurface = createAsyncThunk('openModal', function (newModal, _ref) {
    var dispatch = _ref.dispatch, getState = _ref.getState;
    return new Promise(function (resolve) {
        newModal.resolve = resolve;
        dispatch(addSurface(newModal));
    });
});
var awaitedSurfacesSlice = createSlice({
    name: 'modal',
    initialState: initialState,
    reducers: {
        addSurface: function (state, action) {
            modalId += 1;
            state.modals.push(_objectSpread(_objectSpread({}, action.payload), {}, {
                id: modalId
            }));
        },
        closeSurface: function (state, action) {
            var _topModal$resolve;
            var topModal = state.modals.pop();
            topModal === null || topModal === void 0 || (_topModal$resolve = topModal.resolve) === null || _topModal$resolve === void 0 || _topModal$resolve.call(topModal, action.payload);
        },
        clearSurfaces: function (state) {
            state.modals = [];
        }
    }
});
export var addSurface = (_a = awaitedSurfacesSlice.actions, _a.addSurface), closeSurface = _a.closeSurface, clearSurfaces = _a.clearSurfaces;
export default awaitedSurfacesSlice.reducer;
